import { render, staticRenderFns } from "./teamPreUsageRecord.vue?vue&type=template&id=5612cb63&scoped=true"
import script from "./teamPreUsageRecord.vue?vue&type=script&lang=js"
export * from "./teamPreUsageRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5612cb63",
  null
  
)

export default component.exports